import { cn } from '@repo/videa-components/src/lib/utils';
import Markdown from 'react-markdown';

import { markdownComponents } from './markdownComponents';

interface UserInstructionsProps {
  templateName: string;
  userInstructions: string;
  /** Optional class for the outer wrapper (e.g. extension passes vai-w-full for full width). */
  wrapperClassName?: string;
  /** Optional class for the scrollable content area (e.g. extension adds list styling when typography plugin is not used). */
  contentClassName?: string;
}

/**
 * Displays procedure template user instructions during voice note recording.
 * Shows the template name as a title and renders markdown-formatted instructions.
 */
export const UserInstructions = ({
  templateName,
  userInstructions,
  wrapperClassName,
  contentClassName,
}: UserInstructionsProps) => {
  return (
    <div
      className={cn(
        'vai-flex vai-flex-col vai-flex-1 vai-min-h-0',
        wrapperClassName,
      )}
    >
      <h3 className="vai-text-base vai-font-bold vai-text-gray-900 vai-mb-2 vai-flex-shrink-0">
        {templateName}
      </h3>
      <div className="vai-border vai-border-gray-200 vai-rounded-lg vai-bg-white vai-overflow-hidden vai-flex vai-flex-col vai-flex-1 vai-min-h-0">
        <div
          className={cn(
            'vai-p-4 vai-prose vai-prose-sm vai-text-gray-700 vai-overflow-y-scroll vai-flex-1 vai-min-h-0',
            contentClassName,
          )}
        >
          <Markdown components={markdownComponents}>
            {userInstructions}
          </Markdown>
        </div>
      </div>
    </div>
  );
};
